import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { RADIUS } from 'DesignTokens';
import ExtendedLiquid from '../../services/ExtendedLiquid';
import CardViewLinks, { CardViewLinkHrefs, revealCardViewLinksOnHoverSx } from './CardViewLinks';

export interface PipelineRowCardProps extends Omit<BoxProps, 'title' | 'children'> {
  title: string;
  subtitle?: string;
  amount?: number | null;
  viewLinks?: CardViewLinkHrefs;
  leading?: React.ReactNode;
  actions?: React.ReactNode;
  isHighlighted?: boolean;
  isInAction?: boolean;
}

export default function PipelineRowCard({
  title,
  subtitle,
  amount,
  viewLinks,
  leading,
  actions,
  isHighlighted,
  isInAction,
  sx,
  ...boxProps
}: PipelineRowCardProps) {
  return (
    <Box
      {...boxProps}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        padding: '0.375rem 0.5rem',
        borderRadius: RADIUS.sectionChild,
        backgroundColor: '#FFFFFF',
        border: `1px solid ${Palette.default.border}`,
        opacity: isInAction ? 0.6 : 1,
        ...revealCardViewLinksOnHoverSx,
        ...(isHighlighted && {
          border: `2px solid ${Palette.default.buttonBg}`,
          backgroundColor: Palette.default.activeBg,
        }),
        ...sx,
      }}
    >
      {leading}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          noWrap
          sx={{ fontSize: '0.75rem', fontWeight: 600, color: Palette.tone1.text, lineHeight: 1.3 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            noWrap
            sx={{ fontSize: '0.6875rem', color: Palette.default.disabledText, lineHeight: 1.3 }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {!!amount && (
        <Typography
          noWrap
          sx={{ fontSize: '0.6875rem', fontWeight: 600, color: Palette.tone1.text }}
        >
          {ExtendedLiquid.currencyMillions(amount, true)}
        </Typography>
      )}
      <CardViewLinks hrefs={viewLinks} />
      {actions}
    </Box>
  );
}
